(() => {
  const bundles = {
    1: { label: 'CHOOSE 1', price: 4990, value: 4990, savings: 0, discountCode: '' },
    3: { label: 'BUY 2 GET 1 FREE', price: 9980, value: 14970, savings: 4990, discountCode: 'VELISSE3' },
    5: { label: 'BUY 3 GET 2 FREE', price: 14970, value: 24950, savings: 9980, discountCode: 'VELISSE5' }
  };

  const defaultColours = {
    1: ['Black'],
    3: ['Black', 'Black', 'Nude'],
    5: ['Black', 'Black', 'Black', 'Nude', 'Nude']
  };

  const money = (cents) => `$${(Number(cents) / 100).toFixed(2)}`;
  const toast = document.querySelector('.toast');
  const form = document.querySelector('[data-velisse-bundle-form]');
  const variantsNode = document.getElementById('VelisseProductVariants');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  const sizeIndex = Number(form?.dataset.sizeOptionIndex || 0);
  const colourIndex = Number(form?.dataset.colourOptionIndex || 1);
  const uniqueValues = (index) => [...new Set(variants.map((variant) => String(variant.options?.[index] || '').trim()).filter(Boolean))];
  const sizes = uniqueValues(sizeIndex);
  const colours = uniqueValues(colourIndex);
  const state = { bundle: 3, selections: [] };

  const announce = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 1800);
  };

  const emitCommerce = (eventName, detail = {}) => {
    if (window.VelisseCommerce?.emit) return window.VelisseCommerce.emit(eventName, detail);
    const payload = { event: eventName, source: 'velisse_theme', ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    return payload;
  };

  const optionValue = (variant, index) => String(variant.options?.[index] || '').trim().toLowerCase();
  const findVariant = (size, colour) => {
    const matches = variants.filter((variant) => optionValue(variant, sizeIndex) === String(size).trim().toLowerCase()
      && optionValue(variant, colourIndex) === String(colour).trim().toLowerCase());
    return matches.find((variant) => variant.available === true) || matches[0];
  };

  const ensureSelections = (quantity) => {
    const defaults = defaultColours[quantity] || [];
    const previous = state.selections;
    state.selections = Array.from({ length: quantity }, (_, index) => {
      const previousSelection = previous[index];
      const size = previousSelection && sizes.includes(previousSelection.size) ? previousSelection.size : sizes[0] || '';
      const defaultColour = defaults[index] || colours[0] || '';
      const colour = previousSelection && colours.includes(previousSelection.colour) ? previousSelection.colour : defaultColour;
      return { size, colour };
    });
  };

  const configurationText = () => state.selections.map((selection, index) => `Bra ${index + 1}: ${selection.colour} / ${selection.size}`).join(' · ');

  const syncCards = () => {
    document.querySelectorAll('[data-offer-card]').forEach((card) => {
      card.classList.toggle('selected', Number(card.dataset.offerCard) === state.bundle);
    });
    document.querySelectorAll('[data-select-bundle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.selectBundle) === state.bundle));
    });
  };

  const makeSelect = (labelText, values, selectedValue, braIndex, key) => {
    const label = document.createElement('label');
    const text = document.createElement('span');
    const select = document.createElement('select');
    text.textContent = labelText;
    select.name = `velisse_bra_${braIndex + 1}_${key}`;
    select.setAttribute('aria-label', `Bra ${braIndex + 1} ${labelText.toLowerCase()}`);
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      option.selected = value === selectedValue;
      select.append(option);
    });
    select.addEventListener('change', (event) => {
      state.selections[braIndex][key] = event.target.value;
      syncSummary();
    });
    label.append(text, select);
    return label;
  };

  const renderBraChoices = () => {
    const target = form?.querySelector('[data-bra-choices]');
    if (!target) return;
    target.replaceChildren(...state.selections.map((selection, index) => {
      const row = document.createElement('div');
      const title = document.createElement('strong');
      row.className = 'bra-choice-row';
      title.className = 'bra-choice-number';
      title.textContent = `Bra ${index + 1}`;
      row.append(
        title,
        makeSelect('Colour', colours, selection.colour, index, 'colour'),
        makeSelect('Size', sizes, selection.size, index, 'size')
      );
      return row;
    }));
  };

  const buildItems = () => {
    if (!form) return [];
    const bundle = bundles[state.bundle];
    const properties = {
      _velisse_bundle_id: `velisse-${state.bundle}`,
      _velisse_bundle_label: bundle.label,
      _velisse_bundle_units: String(state.bundle),
      _velisse_bundle_savings: money(bundle.savings),
      _velisse_discount_code: bundle.discountCode,
      _velisse_bundle_configuration: configurationText()
    };
    const grouped = new Map();
    state.selections.forEach((selection) => {
      const variant = findVariant(selection.size, selection.colour);
      if (!variant) return;
      const id = Number(variant.id);
      const existing = grouped.get(id);
      if (existing) existing.quantity += 1;
      else grouped.set(id, { id, quantity: 1, properties });
    });
    return [...grouped.values()];
  };

  const allAvailable = (items) => items.length > 0 && items.every((item) => {
    const variant = variants.find((candidate) => Number(candidate.id) === Number(item.id));
    if (!variant?.available) return false;
    return true;
  });

  function syncSummary() {
    if (!form) return;
    const bundle = bundles[state.bundle];
    const summary = form.querySelector('[data-bundle-summary]');
    const configuration = form.querySelector('[data-bundle-configuration]');
    const price = form.querySelector('[data-bundle-price]');
    const value = form.querySelector('[data-bundle-value]');
    const button = form.querySelector('[data-add-to-cart]');
    const inventory = form.querySelector('[data-inventory-status]');
    const items = buildItems();
    const available = items.reduce((total, item) => total + item.quantity, 0) === state.bundle && allAvailable(items);
    if (summary) summary.textContent = `Your ${state.bundle}-bra selection`;
    if (configuration) configuration.textContent = configurationText();
    if (price) price.textContent = money(bundle.price);
    if (value) value.textContent = bundle.savings ? `${money(bundle.value)} value · Save ${money(bundle.savings)}` : 'No bundle discount';
    document.querySelectorAll('[data-current-bundle]').forEach((node) => { node.textContent = bundle.label; });
    document.querySelectorAll('[data-current-price]').forEach((node) => { node.textContent = money(bundle.price); });
    if (button) {
      button.disabled = !available;
      button.textContent = available ? `Add ${state.bundle} ${state.bundle === 1 ? 'bra' : 'bras'} to bag · ${money(bundle.price)}` : 'Selected combination unavailable';
    }
    if (inventory) {
      inventory.hidden = available;
      const unavailable = state.selections.map((selection, index) => {
        const variant = findVariant(selection.size, selection.colour);
        if (!variant) return `Bra ${index + 1}: ${selection.colour} / ${selection.size} — this option could not be found.`;
        if (!variant.available) return `Bra ${index + 1}: ${selection.colour} / ${selection.size} — currently unavailable online.`;
        return '';
      }).filter(Boolean);
      inventory.textContent = available ? '' : unavailable.join(' ');
    }
  }

  const selectBundle = (quantity, shouldAnnounce = false) => {
    if (!bundles[quantity]) return;
    state.bundle = quantity;
    ensureSelections(quantity);
    syncCards();
    renderBraChoices();
    syncSummary();
    if (shouldAnnounce) announce(`${bundles[quantity].label} selected`);
  };

  document.querySelectorAll('[data-select-bundle]').forEach((button) => {
    button.addEventListener('click', () => {
      selectBundle(Number(button.dataset.selectBundle), true);
      if (!button.closest('#shopify-purchase')) document.querySelector('#shopify-purchase')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-add-to-cart]');
    const status = form.querySelector('[data-inventory-status]');
    const items = buildItems();
    if (items.reduce((total, item) => total + item.quantity, 0) !== state.bundle || !allAvailable(items)) {
      syncSummary();
      return;
    }
    button.disabled = true;
    button.textContent = 'Adding your Velisse set…';
    if (status) status.hidden = true;
    try {
      const addResponse = await fetch(`${form.dataset.cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!addResponse.ok) {
        const error = await addResponse.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'We could not add this set to your bag.');
      }
      const discountCode = bundles[state.bundle].discountCode;
      const discountResponse = await fetch(`${form.dataset.cartUpdateUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: discountCode })
      });
      if (!discountResponse.ok) throw new Error('We could not apply the bundle savings.');
      emitCommerce('velisse_add_to_cart', {
        product_id: String(form.dataset.productId || ''),
        content_ids: items.map((item) => String(item.id)),
        quantity: state.bundle,
        value: bundles[state.bundle].price / 100,
        currency: form.dataset.currency || 'USD',
        bundle: bundles[state.bundle].label,
        configuration: configurationText()
      });
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      button.disabled = false;
      button.textContent = `Add ${state.bundle} ${state.bundle === 1 ? 'bra' : 'bras'} to bag · ${money(bundles[state.bundle].price)}`;
      if (status) {
        status.hidden = false;
        status.textContent = error.message || 'Something went wrong. Please try again.';
      }
    }
  });

  selectBundle(3);

  const sizeGuideDialog = document.querySelector('#VelisseSizeGuide');
  document.querySelectorAll('[data-size-guide-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!sizeGuideDialog?.showModal) return;
      sizeGuideDialog.showModal();
      window.requestAnimationFrame(() => {
        const body = sizeGuideDialog.querySelector('.size-guide-dialog-body');
        if (body) body.scrollLeft = (body.scrollWidth - body.clientWidth) / 2;
      });
    });
  });
  document.querySelectorAll('[data-size-guide-close]').forEach((button) => button.addEventListener('click', () => sizeGuideDialog?.close()));
  sizeGuideDialog?.addEventListener('click', (event) => {
    if (event.target === sizeGuideDialog) sizeGuideDialog.close();
  });

  window.VelisseBundle = {
    bundles,
    buildItems,
    findVariant,
    getState: () => ({ bundle: state.bundle, selections: state.selections.map((selection) => ({ ...selection })) }),
    selectBundle,
    setSelection: (index, selection = {}) => {
      if (!state.selections[index]) return;
      if (sizes.includes(selection.size)) state.selections[index].size = selection.size;
      if (colours.includes(selection.colour)) state.selections[index].colour = selection.colour;
      renderBraChoices();
      syncSummary();
    }
  };
})();
